import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import InboundBins from './InboundBins/index.vue';
import OutboundBins from './OutboundBins/index.vue';
import ReprintBins from './ReprintBins/index.vue';
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';
import download from 'downloadjs';
import jsPDF from 'jspdf';
import JsBarcode from 'jsbarcode';
import Canvg from 'canvg';

export default {
  name: 'bin-sticker',
  components: {
		DatePicker,
		VueElementLoading,
		Canvg,
		download,
		'first': InboundBins,
    'second': OutboundBins,
		'third': ReprintBins
	},
	props: [],
	data() {
		return {
			currentTab: 'First',
			isLoading: false,
			componentKey: 0,
			hubid:'',
			binCount:0,
			tabs: [{
					key: 'First',
					value: 'Inbound'
				},
				{
					key: 'Second',
					value: 'Outbound'
				},
				{
					key: 'Third',
					value: 'Reprint',
					count: ''
				}
			],
			bin:true,
			tab:false,
			ispdf:true,
			binDetails:'',
			isLoadingSearch:false,
			checkAll:'',
			totalcountbin:0,
			BinTable:false,
			showtb:true
		}
	},
	computed: {
		currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.getBinCount();
		this.getBinTableDetails();
	},
	methods: {
		change() {
			this.bin = false;
			this.showtb = false;
			return this.tab = true;
		},

		getBinCount(){
			this.binCount=0;
			this.isLoading = true;
			this.input = ({
				currentHubId: this.hubid
			});

			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'getBinCount',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(async result => {

					if (result.data.ResultCode == 100) {
						this.binCount = result.data.ResponseData.bincount;

						await this.tabs.map(item => {
							if(item.value === 'Inbound'){
								item.count = result.data.ResponseData.inbound;
							}
							if(item.value === 'Outbound'){
								item.count = result.data.ResponseData.outbound;
							}
						});

					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoading = false;
				}, error => {
					console.error(error); this.isLoading = false;
				})
		},

		check() {
			if(typeof InstallTrigger !== 'undefined' == true){ this.checkAll = !this.checkAll; }
			this.BinArr = [];
			if (this.checkAll) {
				this.isLoadingSearch = true; let str = '';
				for (let i in this.binDetails) {
					this.BinArr.push(this.binDetails[i]);

					// str = str.concat('n\n' + 'M0751\n' + 'KW0391\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' +
					// 'A2\n' + '1X1100002510000L389001\n' + '1X1100000510000L389001\n' + '2a6305502210056' + this.binDetails[i].ptlid + '\n' +
					// '2911A1201890036' + this.binDetails[i].ptlid + '\n' + '2922A2502120238' + this.binDetails[i].groupcode + '\n' +
					// '2922A2502120158' + this.binDetails[i].binno + '\n' +
					// 'Q0001\n' + 'E' + '\n');
					str = str.concat(`^XA
						^SZ2^JMA
						^MCY^PMN
						^PW812
      					~SD12^MD0^MTD
						~JSN
						~SD25^MD0
						^JZY
						^LH0,0^LRN
						^XZ
						^XA
						^FO7,570
						^GB801,0,3^FS
						^FO8,40
						^GB795,0,3^FS
						^FT225,461
						^CI0
						^A0B,102,105^FD${this.binDetails[i].groupcode}^FS
						^FT394,472
						^A0B,102,138^FD${this.binDetails[i].binno}^FS
						^FO482,112
						^BY4^BCB,102,N,N^FD>:${this.binDetails[i].ptlid}^FS
						^FT635,393
						^A0B,56,76^FD${this.binDetails[i].ptlid}^FS
						^PQ1,0,1,Y
						^XZ`);
						this.prnData = str;
							console.log(this.prnData);
				}
				this.isLoadingSearch = false;
			}
		},
		updateCheck(){
			if(this.binDetails.length == this.BinArr.length){
				 this.checkAll = true;
			}else{
				 this.checkAll = false;
			}
		},

		async bulkAction(elem){
			this.barc = [];
			if(this.BinArr.length>0){
				let str = ''; this.isLoadingSearch = true;
				for (var i = 0; i < this.BinArr.length; i++) {
					// str = str.concat('n\n' + 'M0751\n' + 'KW0391\n' + 'O0220\n' + 'V0\n' + 'f303\n' + 'D\n' + 'L\n' + 'D11\n' +
					// 'A2\n' + '1X1100002510000L389001\n' + '1X1100000510000L389001\n' + '2a6305502210056' + this.BinArr[i].ptlid + '\n' +
					// '2911A1201890036' + this.BinArr[i].ptlid + '\n' + '2922A2502120238' + this.BinArr[i].groupcode + '\n' +
					// '2922A2502120158' + this.BinArr[i].binno + '\n' + 'Q0001\n' + 'E' + '\n');
					str = str.concat(`^XA
					^SZ2^JMA
					^MCY^PMN
					^PW812
      				~SD12^MD0^MTD
					~JSN
					~SD25^MD0
					^JZY
					^LH0,0^LRN
					^XZ
					^XA
					^FO7,570
					^GB801,0,3^FS
					^FO8,40
					^GB795,0,3^FS
					^FT225,461
					^CI0
					^A0B,102,105^FD${this.BinArr[i].groupcode}^FS
					^FT394,472
					^A0B,102,138^FD${this.BinArr[i].binno}^FS
					^FO482,112
					^BY4^BCB,102,N,N^FD>:${this.BinArr[i].ptlid}^FS
					^FT635,393
					^A0B,56,76^FD${this.BinArr[i].ptlid}^FS
					^PQ1,0,1,Y
					^XZ`);
					this.prnData = str;
						console.log(this.prnData);
					let barcUrl = await this.textToBase64Barcode(this.BinArr[i].ptlid);
					this.barc.push({'base64':barcUrl, 'groupcode':this.BinArr[i].groupcode, 'rackid':this.BinArr[i].binno, 'ptlbinmappingid':this.BinArr[i].ptlbinmappingid});
				}
				this.isLoadingSearch = false;

				if(this.barc.length>0 && elem===0){
					await this.downloadPDF();
				}else{
					await this.printerSticker(this.prnData);
				}
			}else{
				this.$alertify.error('Error: Please check alteast one checkbox.');
			}
		},

		async textToBase64Barcode(text){
		 var canvas = document.createElement("canvas");
		 JsBarcode(canvas, text, {format: "CODE39", displayValue: true, fontSize:20, textmargin:"0", fontoptions:"bold"});
		 return canvas.toDataURL("image/png");
		},

		async downloadPDF() {
			const doc = new jsPDF('p', 'pt', 'a4');
			doc.setFontSize(55).setFontType("bold")
			doc.setLineWidth(.5)

			let o=0; let e=0;
			for (var i = 0; i < this.barc.length; i++) {

			 if(o==2 && e==2){ o=0; e=0; doc.addPage(); }

			 if(i % 2 == 0) {
				 // if the number is even
				 doc.rect(32, (45+o*430), 216, 288)
				 doc.rect(66, (45+o*430), 144, 288)
				 doc.addImage(this.barc[i].base64, 'JPEG', 75, (270+o*430), 128, 50)
				 doc.text(80, (130+o*430), this.barc[i].groupcode)
				 doc.text(100, (220+o*430), this.barc[i].rackid)
				 o++;
			 }
			 else {
				 // if the number is odd
				 doc.rect(334, (45+e*430), 216, 288)
				 doc.rect(368, (45+e*430), 144, 288)
				 doc.addImage(this.barc[i].base64, 'JPEG', 377, (270+e*430), 128, 50)
				 doc.text(380, (130+e*430), this.barc[i].groupcode)
				 doc.text(400, (220+e*430), this.barc[i].rackid)
				 e++;
			 }
			}
			doc.save("bin-sticker.pdf");
		},
		printerSticker(prnData) {

			this.input = {
				prnData: prnData,
				bagNumber: moment().format('DD-MM-YYYY')
			}
			this.isLoadingSearch = true;
			axios({
					method: "POST",
					url: "http://localhost:4500/printer/printbagsticker",
					data: this.input,
				})
				.then(result => {
					console.log(result);
					if (result.data.ResultCode == 100) {
						this.updateBagPrintLog();
						this.$alertify.success(result.data.ReturnMessage);
						this.$validator.reset();
						this.errors.clear();
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					var code = error.response == undefined ? code = 0 : error.response.status;
					if (code == 500) {
						this.$alertify.error("Printer API error");
						console.log(error.response.statusText);
					} else if (error) {
						this.$alertify.error("Printer not connected")
					}
				})
				this.isLoadingSearch = false;
		},

		getBinTableDetails(){
			this.BinArr = this.barc = []; this.totalcountbin=0; this.binDetails = [];
			this.input = ({
			  currentHubId: this.hubid
			});

			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'getUpdatedBin',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(async result => {
					if (result.data.ResultCode == 100) {
						this.binDetails = result.data.ResponseData[0];
						this.totalcountbin = result.data.TotalCount;
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					 console.error(error);
				})
		},
		reload() {
			location.reload(true);
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BinSticker/BinSticker.js